import { Box } from '@mui/material';

interface ProductIframeProps {
  src: string;
  title: string;
  onLoad?: () => void;
}

export function ProductIframe({ src, title, onLoad }: ProductIframeProps) {
  return (
    <Box
      component="iframe"
      src={src}
      title={title}
      onLoad={onLoad}
      sx={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
        bgcolor: 'background.paper',
      }}
    />
  );
}
